import { scope, type } from 'arktype';

import { addressSchema } from '@/schemas/address';
import { BusinessRelationshipType, ContactType } from '@/types/contacts';
import { CountryType } from '@/types/country';
import { checkStringValidSwiftCharacters } from '@/utility/checkStringValidSwiftCharacters';

export const recipientSchema = scope({
  Individual: {
    type: type.enumerated(ContactType.individual),
    firstName: type('string > 0')
      .configure({ message: 'VALIDATION_REQUIRED' })
      .narrow(checkStringValidSwiftCharacters),
    lastName: type('string > 0')
      .configure({ message: 'VALIDATION_REQUIRED' })
      .narrow(checkStringValidSwiftCharacters),
    country: type
      .valueOf(CountryType)
      .filter((c: CountryType): boolean => c !== CountryType.unset)
      .configure({ message: 'VALIDATION_REQUIRED' })
      .as<CountryType>(),
    address: addressSchema,
    businessRelationship: type
      .valueOf(BusinessRelationshipType)
      .filter((c: BusinessRelationshipType): boolean => c !== BusinessRelationshipType.unset)
      .configure({ message: 'VALIDATION_REQUIRED' })
      .as<BusinessRelationshipType>(),
  },
  Company: {
    type: type.enumerated(ContactType.company),
    legalEntityName: type('string > 0')
      .configure({ message: 'VALIDATION_REQUIRED' })
      .narrow(checkStringValidSwiftCharacters),
    country: type
      .valueOf(CountryType)
      .filter((c: CountryType): boolean => c !== CountryType.unset)
      .configure({ message: 'VALIDATION_REQUIRED' })
      .as<CountryType>(),
    address: addressSchema,
    businessRelationship: type
      .valueOf(BusinessRelationshipType)
      .filter((c: BusinessRelationshipType): boolean => c !== BusinessRelationshipType.unset)
      .configure({ message: 'VALIDATION_REQUIRED' })
      .as<BusinessRelationshipType>(),
  },
}).type('Individual | Company');
